module.exports = __webpack_public_path__ + "static/img/newsdetail.61b9791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/newsdetail.jpg
// module id = w8sZ
// module chunks = 1